<template>
    <p>Questionaire management table</p>
    <div class="d-flex flex-column">
        <v-row class="ma-0 justify-space-between align-center mt-6 mb-3 align-center">
            <v-col 
                v-if="true || renderedFilters?.includes('type')"
                cols="12" 
                md="4" 
                class="d-flex align-center"
            >
                <v-select 
                    v-model="filters.type" 
                    label="Tipo de Avaliação" 
                    :items="assessmentTypesList" 
                    item-title="title" 
                    item-value="value" 
                    autocomplete="off"
                    :clearable="!props.assessmentType"
                    :readonly="!!props.assessmentType"
                    :menu-icon="!!props.assessmentType ? '' : undefined"
                />
            </v-col>
            <v-col 
                v-if="true || renderedFilters?.includes('year')"
                cols="12" 
                :md="4" 
                class="d-flex align-center"
            >
                <v-autocomplete 
                    v-model="filters.year" 
                    label="Ano da avaliação" 
                    :items="yearsList"
                    autocomplete="off"
                    clearable
                    :disabled="!resolvedAssessmentApi"
                />
            </v-col>
            <v-col 
                v-if="false && renderedFilters?.includes('evaluator_user_ids')"
                cols="12" 
                :md="4" 
                class="d-flex align-center"
            >
                <v-autocomplete 
                    v-model="filters.evaluator_user_ids" 
                    label="Avaliador(a)" 
                    :items="usersList" 
                    item-value="id" 
                    :multiple="true" 
                    :loading="isLoadingUsersList" 
                    :disabled="isInitialLoadingUsersList || !resolvedAssessmentApi" 
                    :item-title="(item) => `${item?.worker_code ? item.worker_code : 'Avaliador(a) sem código'} - ${item?.name ? item.name : 'Avaliador(a) sem nome'}`" 
                    autocomplete="off"
                    clearable
                />
            </v-col>

            <v-col 
                v-if="true || renderedFilters?.includes('subject_user_ids')"
                cols="12" 
                :md="4" 
                class="d-flex align-center"
            >
                <v-autocomplete 
                    v-model="filters.subject_user_ids" 
                    label="Colaborador(a) avaliado(a)" 
                    :items="usersList" 
                    item-value="id" 
                    :multiple="true" 
                    :loading="isLoadingUsersList" 
                    :disabled="
                        isInitialLoadingUsersList 
                        || !resolvedAssessmentApi 
                        || (
                            filters.type === 'self'
                            && !sessionStore.hasPermission([
                                'self.assessment.list.any',
                                'self.assessment.list.department'
                            ])
                        )
                        
                    " 
                    :item-title="(item) => `${item?.worker_code ? item.worker_code : 'Colaborador(a) sem código'} - ${item?.name ? item.name : 'Colaborador(a) sem nome'}`" 
                    autocomplete="off"
                    clearable
                />
            </v-col>
              <!-- TODO: add select / switch for evaluation status (draft vs submitted) -->

            
        </v-row>
        <v-row class="mx-0 mb-4">
            <v-col cols="12" md="auto" class="px-0 d-flex justify-end flex-grow-1">
                <v-btn 
                    :prepend-icon="
                        !resolvedAssessmentApi
                        ? 'mdi-alert'
                        : (
                            isLoadingQuestionaresList 
                            ? 'mdi-loading mdi-spin'
                            : 'mdi-filter'
                        )
                    " 
                    :color="
                        !resolvedAssessmentApi
                        ? 'grey-darken-4'
                        : 'primary'
                    " 
                    :variant="
                        !resolvedAssessmentApi
                        ? 'flat'
                        : 'outlined'
                    "
                    @click="fetchQuestionaires"
                    :disabled="isLoadingQuestionaresList || !resolvedAssessmentApi"
                >
                    {{
                        !resolvedAssessmentApi
                        ? 'Escolha o tipo de Avaliação'
                        : (
                            isLoadingQuestionaresList
                            ? 'Atualizando...'
                            : 'Filtrar'
                        )
                    }}
                </v-btn>
            </v-col>
        </v-row>
        <v-row class="ma-0">
            <v-col cols="12" md="auto" class="px-0 d-flex justify-end  flex-grow-1">
                <v-btn 
                    :prepend-icon="'mdi-plus'" 
                    color="primary" 
                    class="mt-4 mb-6"
                    @click="openDialogForAction('new', filters.type)"
                >
                    Nova Avaliação
                </v-btn>
            </v-col>
        </v-row>
        <v-data-table-server
            v-model:items-per-page="filters.per_page"
            v-model:page="filters.page"
            :headers="questionaireManamentTableHeaders"
            :items="questionairesList?.[filters.type] ?? []"
            :items-length="filters.total ?? 0"
            :loading="isLoadingQuestionaresList"
            item-value="id"
            :mobile="mdAndDown"
            hide-default-footer
            @update:sort-by="handleSortingUpdate"
        >
            <template #item.subject="{item}">
                {{ resolvedSubject(item) }}
            </template>
            <template #item.status="{item}">
                <v-chip
                    :prepend-icon="
                        item?.status === 'submitted'
                        ? 'mdi-archive-check'
                        : 'mdi-file-edit-outline'
                    "
                    :color="
                        item?.status === 'submitted'
                        ? 'success'
                        : 'warning'
                    "
                    :variant="
                        item?.status === 'submitted'
                        ? 'outlined'
                        : 'flat'
                    "
                >
                    {{
                        item?.status === "submitted"
                        ? "Submetida"
                        : "Rascunho"
                    }}
                </v-chip>
            </template>
            <template #item.actions="{item}">
                <div class="d-flex flex-column flex-md-row justify-lg-end ga-2 align-center">
                    <v-tooltip v-if="item?.can_get" text="Ver Avaliação" location="top">
                        <template #activator="{props}">
                            <v-btn 
                                v-bind="props" 
                                icon="mdi-eye" 
                                color="info" 
                                rounded="xl" 
                                size="x-small" 
                                variant="outlined"
                                @click="openDialogForAction('get', filters.type, item?.id)"
                            />
                        </template>
                    </v-tooltip>
                    <!-- <v-tooltip 
                        v-if="item?.can_get" 
                        text="Ver detalhes (nova aba/página)" 
                        location="top"
                    >
                        <template #activator="{props}">
                            <v-btn 
                                v-bind="props" 
                                icon="mdi-open-in-new" 
                                color="info" 
                                rounded="xl" 
                                size="x-small" 
                                variant="outlined"
                                @click="openDetailsInNewTab(filters.type, item.id)"
                            />
                        </template>
                    </v-tooltip> -->
                    <v-tooltip 
                        v-if="item?.can_update" 
                        text="Editar / Atualizar" 
                        location="top"
                    >
                        <template #activator="{props}">
                            <v-btn 
                                v-bind="props" 
                                icon="mdi-pencil" 
                                color="info" 
                                rounded="xl" 
                                size="x-small" 
                                variant="flat"
                                @click="openDialogForAction('update', filters?.type, item?.id)"
                            ></v-btn>
                        </template>
                    </v-tooltip>
                    <v-tooltip 
                        v-if="item?.can_submit" 
                        text="Submeter (e trancar)" 
                        location="top"
                    >
                        <template #activator="{props}">
                            <v-btn 
                                v-bind="props" 
                                icon="mdi-send-lock" 
                                color="success" 
                                rounded="xl" 
                                size="x-small" 
                                variant="flat"
                                @click="openDialogForAction('submit', filters?.type, item?.id)"
                            ></v-btn>
                        </template>
                    </v-tooltip>
                </div>
            </template>
        </v-data-table-server>
        <div class="d-flex justify-end align-center">
            <strong>{{ filters.from ?? 1 }} - {{ filters.to ?? '??' }} / {{ filters.total ?? '??' }}</strong>
            <v-pagination
                v-model="filters.page"
                :length="filters.last_page ?? 1"
                :total-visible="0"
                @update:model-value="fetchQuestionaires"
            />
        </div>
    </div>
</template>

<script setup>
import { computed, onMounted, readonly, ref } from 'vue';
import SelfAssessmentQuestionaires from "@/api/assessments/questionaires/SelfAssessmentQuestionaires.js"
import AscendingAssessmentQuestionaires from "@/api/assessments/questionaires/AscendingAssessmentQuestionaires.js"
import DownwardAssessmentQuestionaires from "@/api/assessments/questionaires/DownwardAssessmentQuestionaires.js"
import { useSessionStore } from '@/stores/SessionStore';
import { useDisplay } from 'vuetify';
import {useDialog} from "@internal_projects_dd/universal-dialog";
import AssessmentCreationForm from './AssessmentCreationForm.vue';
import AssessmentQuestionaireForm from './AssessmentQuestionaireForm.vue';
import manipulators from "@/composables/stringManipulations.js";
import { useRouter } from 'vue-router';

const { mdAndDown } = useDisplay();
const props = defineProps({
    assessmentType: {
        type: String,
        default: null,
        validator: (value, props) => {
            return [null, "self", "ascending", "downward"].includes(value);
        },
    },
    renderedFilters: {
        type: Array,
        default: () => [],
    },

});

const dialog = useDialog();
const router = useRouter();
const sessionStore = useSessionStore();

const resolvedBulkCreationPermissions = computed(() => {
    
    switch (props.assessmentType) {
        case "self":
            
            return [
                "self.assessment.create.any",
                "self.assessment.create.department",
            ];
        case "ascending":
            
            return [
                "ascending.assessment.create.any",
                "ascending.assessment.create.department",
            ];
        case "downward":
            
            return [
                "downward.assessment.create.any",
                "downward.assessment.create.department",
            ];
    
        default:
            return [];
    }
}); 

const resolvedAssessmentApi = computed(() => {
    const type = filters.value?.type ?? props.assessmentType ?? null;
    if(type !== null && type !== undefined) {

        switch (type) {
            case "self":
                return SelfAssessmentQuestionaires;
            case "ascending":
                return AscendingAssessmentQuestionaires;
            case "downward":
                return DownwardAssessmentQuestionaires;
        
            default:
                throw new RangeError("Invalid value for 'assessmentType' property!");
        }
    }

    return null;
}) ;

const currentYear = new Date().getFullYear();
const firstYear = 2000;
const questionaireManamentTableHeaders = computed(() => {
    const headers = [
        {
            title: "Ano",
            align: "center",
            sortable: true,
            key: "year",
        },
        {
            title: "Estado",
            align: "center",
            sortable: true,
            key: "status"
        },
        {
            title: "Ações",
            align: "end",
            sortable: false,
            key: "actions",
        }
    ];

    if (filters.value.type !== "self" 
        || sessionStore.hasPermission([
            "self.assessment.list.any",
            "self.assessment.list.department",
        ])
    ) {
        headers.unshift(
            {
                title: "Colaborador(a)",
                align: "start",
                sortable: true,
                key: "subject",
            }
        );
    }

    return headers;
})

const isLoadingUsersList = ref(false);
const isInitialLoadingUsersList = ref(false);
const isLoadingQuestionaresList = ref(false);

const filters = ref({
    type: props.assessmentType ?? null,
    year: props.year ?? null,
    evaluator_user_ids: null,
    subject_user_ids: null,
    status: null,
    page: 1,
    per_page: 25,
    last_page: 1,
    from: null,
    to: null,
    total: null,
    order_by: null,
    direction: null,
});

const renderedFilters = computed(() => {
    let renderList = [
        "year"
    ];
    console.log(sessionStore);
    switch (filters.value?.type) {
        case "self":
            if(sessionStore.hasPermission([
                "self.assessment.list.any",
                "self.assessment.list.department"
            ])) {
                renderList.push("subject_user_ids");
            }
            break;
    
        case "ascending":
        case "downward":
            renderList.push("subject_user_ids");
    
            break;
    
        default:
            renderList = [
                "year",
                "evaluator_user_ids",
                "subject_user_ids"
            ];
            break;
    }

    

    if(!props.assessmentType) {
        renderList.push("type");
    }
    return renderList;
});

const assessmentTypesList = ref([
    {
        title: "Auto-Avaliações",
        value: "self"
    },
    {
        title: "Ascendente",
        value: "ascending",
    },
    {
        title: "Descendente",
        value: "downward"
    }
]);
const usersList = ref([]);
const questionairesList = ref({
    "self": [],
    "ascending": [],
    "downward": [],
});
const yearsList = ref(
    Array.from(
        Array(currentYear - firstYear + 1).keys(),
        (v) => v + firstYear
    )?.reverse()
)



function resolvedSubject(questionaire)  {
    if(!questionaire) return;

    switch (filters.value?.type) {
        case "self":
            
            return `${questionaire?.user?.worker_code ?? 'Colaborador(a) sem código'} - ${questionaire?.user?.name ?? 'Colaborador(a) sem nome'}`;

        case "ascending":
            return `${questionaire?.subject?.worker_code ?? 'Colaborador(a) sem código'} - ${questionaire?.subject?.name ?? 'Colaborador(a) sem nome'}`;
            break;

        case "downward":
            return `${questionaire?.subject_user?.worker_code ?? 'Colaborador(a) sem código'} - ${questionaire?.subject_user?.name ?? 'Colaborador(a) sem nome'}`;
            break;
    
        default:
            break;
    }
}

function openDetailsInNewTab(assessmentType, assessmentId) {
    const route = router.resolve({
        name: "assessment-type-details",
        params: {
            id: assessmentId,
            type: assessmentType,
        }
    })

    window.open(route.href, "_blank", "noopener");
}

async function openDialogForAction(action, assessmentType = null, assessmentId = null) {
    if(!action) {
        return;
    }

    const idempotency_key = self?.crypto?.randomUUID() ?? null;

    const componentProperties = resolveComponentPropertiesForAction(action, assessmentType, assessmentId);

    const resolvedComponent = resolveComponentForAction(action);

    const actionSpecificDialogOptions = resolveDialogOptionsForAction(action, assessmentType);

    componentProperties.idempotency_key = idempotency_key;

    componentProperties.onSubmit = createAssessmentActionSubmitHandler(action);

    await dialog.open({
        component: resolvedComponent,
        props: {
            ...componentProperties
        },
        options: {
            ...actionSpecificDialogOptions
        }
    });
}

function createAssessmentActionSubmitHandler(action) {

    if(["read", "get"].includes(action)) {
        return null;
    }

    if(["create", "new"].includes(action)) {
        return async (payload) => resolvedAssessmentApi.value.create(payload)
    }
    
    const actionMethod = {
       update: "update",
       edit: "update",
       submit: "submit",
       lock: "submit",
    }[action];

    if (!actionMethod) {
        throw new RangeError(`Invalid action: '${action}'!`);
    }
    
    return async (payload) => resolvedAssessmentApi.value[actionMethod](payload.id, payload)
}

function resolveComponentForAction(action) {
    switch (action) {
        case "bulk-create":
        case "bulk":
        case "create":
        case "new":
        case "bulk-create-standalone":
        case "bulk-standalone":
        case "create-standalone":
        case "new-standalone":
            return AssessmentCreationForm;
            
        case "edit":
        case "get":
        case "lock":
        case "read":
        case "submit":
        case "update":
        case "edit-standalone":
        case "get-standalone":
        case "lock-standalone":
        case "read-standalone":
        case "submit-standalone":
        case "update-standalone":

            return AssessmentQuestionaireForm;
    
        default:
             throw new RangeError(
                `Invalid action: '${action}'!`
            );
    }
}

function resolveComponentPropertiesForAction(action, assessmentType, assessmentId) {
    return {
        disabled: false,
        action: action,
        readonly: ["read", "get"].includes(action),
        assessmentType: assessmentType,
        assessmentId: assessmentId ,
        standalone: action.includes("standalone"),
        usersList: usersList.value,
        isLoadingUsersList: isLoadingUsersList.value,
        bulkCreate: 
            action.includes("bulk") 
            || sessionStore?.user?.hasPermission(
                resolvedBulkCreationPermissions.value
            ),
    };
}

function resolveDialogOptionsForAction(action, assessmentType) {
    const dialogOptions = {
        titleBackgroundColor: "transparent",
        titleTextColor: "primary",
        persistent: true,
        maxWidth: ["new", "create"].includes(action)
                    ? 540
                    : 960
        ,
        showCancel: false,
        onConfirm: "submit",
        confirmActionColor: "primary",
        onConfirmFailureExpectedResult: false,
        onConfirmFailureThrow: true,

    }
    let assessmentTypeLabel;
    switch (assessmentType) {
        case "self":
            assessmentTypeLabel = "Auto-avaliação";
            break;
    
        case "ascending":
            assessmentTypeLabel = "Avaliação Ascendente";
            break;
    
        case "downward":
            assessmentTypeLabel = "Avaliação Descendente";
            break;
    
        default:
            throw new RangeError(
                `Invalid assessment type: '${assessmentType}'!`
            );
            
    }

    let uiActionVerb;
    let uiActionAdjective;
    let uiActionUnderWayLabel;
    let apiMethod;

    switch (action) {

        case "create":
        case "new":
        case "create-standalone":
        case "new-standalone":

            uiActionVerb = "criar";
            uiActionAdjective = "criado";
            uiActionUnderWayLabel = "criando";

            dialogOptions.confirmActionIcon = "mdi-plus";

            apiMethod = "create";

            break;
            
        case "read":
        case "get":
        case "read-standalone":
        case "get-standalone":

            dialogOptions.onConfirm = async () => true;
            dialogOptions.confirmActionIcon = "mdi-close";
            dialogOptions.persistent = false;
            dialogOptions.title = `Detalhes da ${assessmentTypeLabel}`;
            dialogOptions.confirmActionText = "Fechar"
            dialogOptions.onConfirmActionText = "Fechando";
            
            break;
        
        case "edit":
        case "update":
        case "edit-standalone":
        case "update-standalone":

            uiActionVerb = "atualizar";
            uiActionAdjective = "atualizado";
            uiActionUnderWayLabel = "atualizando";

            dialogOptions.confirmActionIcon = "mdi-content-save";
            
            dialogOptions.onConfirm = "submitFromDialog";
            dialogOptions.onConfirmFailureThrow = false;

            apiMethod = "update";
            
            break;

        case "submit":
        case "lock":
        case "submit-standalone":
        case "lock-standalone":

            uiActionVerb = "submeter";
            uiActionAdjective = "submetida";
            uiActionUnderWayLabel = "submetendo";

            dialogOptions.confirmActionIcon = "mdi-send-lock";

            dialogOptions.onConfirm = "submitFromDialog";
            // dialogOptions.onConfirmFailureThrow = false;

            apiMethod = "submit";

            break;

        case "bulk":
        case "bulk-create":
        case "bulk-standalone":
        case "bulk-create-standalone":

            uiActionVerb = "criar";
            uiActionAdjective = "criadas";
            uiActionUnderWayLabel = "criando";

            dialogOptions.onconfirmActionIcon = "mdi-plus-box-multiple-outline";

            apiMethod = "bulk-create";

            break;
    
        default:
            throw new RangeError(
                `Invalid action: '${action}'!`
            );
    }

    // returning early in read action since it does not need any 
    // further options
    if (["read", "get", "read-standalone", "get-standalone"].includes(action)) {
        return dialogOptions;
    }

    // set shared dynamic properties
    dialogOptions.title = `${manipulators.firstLetterToUpperCase(uiActionVerb)} ${assessmentTypeLabel}`;
    dialogOptions.confirmActionText = `${manipulators.firstLetterToUpperCase(uiActionVerb)} ${assessmentTypeLabel}`;
    dialogOptions.onConfirmActionText = `${manipulators.firstLetterToUpperCase(uiActionUnderWayLabel)} ${assessmentTypeLabel}...`;
    
    dialogOptions.onConfirmSuccess = async (result) => {
        fetchQuestionaires();

        await openSuccessDialog(
            `${assessmentTypeLabel} ${uiActionAdjective} com sucesso!`
        );

        return result;
    }

    dialogOptions.onConfirmError = async (error, currentDialog) => {
        console.error(
            `Erro a ${uiActionVerb} ${assessmentTypeLabel}:`,
            String(error)
        );

        currentDialog.options.onConfirmFailedErrorTitle = 
                    error?.reason
                    ?? `Erro a ${uiActionVerb} ${assessmentTypeLabel}:`;

                currentDialog.options.onConfirmFailedErrorMessage = 
                    (Object.values(error?.response?.data?.errors ?? {})?.flat().join("\n")
                    || error?.response?.data?.message)
                    ?? error?.message
                    ?? String(error)
                    ?? `Não foi possível ${uiActionVerb} a ${assessmentTypeLabel}! Tente novamente`;
    }


    return dialogOptions;
}

async function openSuccessDialog(bodyText) {
    await dialog.open({
        options: {
            bodyText,
            persistent: true,
            maxWidth: 500,
            showCancel: false,
            confirmActionIcon: "",
            confirmActionText: "Ok",
            confirmActionColor: "primary",
        },
    });
}

function handleSortingUpdate(updatedSorting = []) {
    const sorting = Array.isArray(updatedSorting)
        ? updatedSorting[0]
        : updatedSorting;

    if (!sorting?.key || !sorting?.order) {
        return;
    }

    filters.value.order_by = sorting.key;
    filters.value.direction = sorting.order;
    filters.value.page = 1;
    fetchQuestionaires();
}

async function fetchQuestionaires() {
    
    const api = resolvedAssessmentApi.value;

    if(isLoadingQuestionaresList.value || !api) {
        return;
    }
    isLoadingQuestionaresList.value = true;

    api.index({
        ...filters.value
    })
    .then((response) => {
        const isPaginated = Array.isArray(response?.data?.data);

        const updatedList = response?.data?.data
                            ?? response?.data
                            ?? [];

        questionairesList.value[filters.value.type] = updatedList;

        if(isPaginated) {
            filters.value.page = response?.data?.page;
            filters.value.last_page = response?.data?.last_page;
            filters.value.total = response?.data?.total;
            filters.value.from = response?.data?.from;
            filters.value.to = response?.data?.to;
        }
        else {
            const maxElements = updatedList?.length;
            filters.value.page = 1;
            filters.value.last_page = 1;
            filters.value.total = maxElements;
            filters.value.from = 1;
            filters.value.to = maxElements;
        }
    })
    .catch((error) => {
        console.error(
            "There was an error getting the list of assessments:",
            error
        );
    })
    .finally(() => {
        isLoadingQuestionaresList.value = false;
    })
}

async function resolveSelfAssessmentAction(action) {
    switch (action) {
        case value:
            
            break;
    
        default:
            break;
    }
}

async function resolveAscendingAssessmentAction(action) {

}

async function resolveDownwardAssessmentAction(action) {

}

function resolveDialogPropertiesForAssessmentTypeAndAction(params) {
    
}

onMounted(() => {
    fetchQuestionaires();
})
</script>